import React, { useState, useEffect, useRef } from "react";
import { useLocation, useNavigate, Link } from "react-router-dom";
import "../../../css/dashboard.css"
import axios from 'axios';
import CommonTable from "../../component/table_list/common_table";
import CommonTableRow from "../../component/table_list/common_tablerow";
import CommonTableColumn from "../../component/table_list/common_tablecolumn";
import Pagination from "react-js-pagination";
import styled from "styled-components"
import Menu from "../../component/main_menu"
import { formatDate } from "../../utils/format_date"
import { useAuthContext } from '../../common/ProtectedLayout';

function ActionLog(props) {

    const location = useLocation();
    const navigate = useNavigate();
    const [isValidAccess, setIsValidAccess] = useState(false); // 유효한 접근 상태

    const [actionList, setActionList] = useState([]);
    const [page, setPage] = useState(1);
    const items = 10;
    const hadlePageChange = (page) => { setPage(page) };
    const [reserveCount, setReserveCount] = useState([]);

    const getActionLog = async () => {
        try {
            const getPage = (page - 1) * 10;
            const action_result = await axios.get(`/ActionLog/${getPage}`);
            setActionList(action_result.data.message);
        } catch (error) {
            console.error('Error fetching reservation count:', error.message);
        }
    };
    const getReserveCount = async () => {
        try {
            const reserve_result = await axios.get('/ActionLogCount');
            setReserveCount(reserve_result.data.message);
        } catch (error) {
            console.error('Error fetching reservation count:', error.message);
        }
    }
    useEffect(() => {
        getActionLog();
    }, [page])

    useEffect(() => {
        setIsValidAccess(true);
        getActionLog();
        getReserveCount();
    }, [location.state, navigate]);

    // 유효한 접근이 아닌 경우 렌더링하지 않음
    if (!isValidAccess) {
        return null;
    }

    // Helper to parse action detail string
    const parseActionDetail = (actionString, excludeKeys = []) => {
        if (!actionString) return null;

        // Regex to find content inside square brackets [ key : value ]
        const regex = /\[(.*?):(.*?)\]/g;
        const matches = [...actionString.matchAll(regex)];

        if (matches.length === 0) {
            return actionString; // Return original string if no matches
        }

        const filteredMatches = matches.filter(match => {
            const key = match[1].trim();
            return !excludeKeys.includes(key);
        });

        if (filteredMatches.length === 0) {
            return null; // Return null if all items are excluded
        }

        return (
            <TagContainer>
                {filteredMatches.map((match, index) => {
                    const key = match[1].trim();
                    const value = match[2].trim();
                    return (
                        <DetailTag key={index}>
                            <TagLabel>{key}</TagLabel>
                            <TagValue>{value}</TagValue>
                        </DetailTag>
                    );
                })}
            </TagContainer>
        );
    };

    // Helper to extract specific key value
    const getReservationNumber = (actionString) => {
        if (!actionString) return '-';
        const regex = /\[\s*예약번호\s*:\s*(.*?)\s*\]/;
        const match = actionString.match(regex);
        return match ? match[1] : '-';
    };

    return (
        <div className="dashboard-container">
            <div className="content-container">
                <div className="small" style={{ marginTop: '50px', textAlign: 'center' }}>
                </div>
                <div style={{ marginTop: '10px' }}>
                    <CommonTable headerTitle={['No', '아이디', '항목', '예약번호', '내용', '변경일자']}>
                        {
                            actionList.map((reserve, index) => {
                                return (
                                    <CommonTableRow key={index} idx={reserve.idx} kind={'notDetail'} >
                                        <CommonTableColumn>{Math.max(reserveCount - 1, 1) - ((page - 1) * 10) - index}</CommonTableColumn>
                                        <CommonTableColumn>{reserve.id}</CommonTableColumn>
                                        <CommonTableColumn>{reserve.page}</CommonTableColumn>
                                        <CommonTableColumn>{getReservationNumber(reserve.action)}</CommonTableColumn>
                                        <CommonTableColumn>{parseActionDetail(reserve.action, ['예약번호'])}</CommonTableColumn>
                                        <CommonTableColumn>{formatDate(reserve.date)}</CommonTableColumn>
                                    </CommonTableRow>
                                )
                            })
                        }
                    </CommonTable>
                </div>
                <PaginationBox>
                    <Pagination
                        activePage={page}
                        itemsCountPerPage={items}
                        totalItemsCount={Math.max(reserveCount - 1, 1)}
                        pageRangeDisplayed={10}
                        onChange={hadlePageChange}>
                    </Pagination>
                </PaginationBox>
            </div>
        </div >
    );

}


const PaginationBox = styled.div`
  .pagination { display: flex; justify-content: center; margin-top: 15px;}
  ul { list-style: none; padding: 0; }
  ul.pagination li {
    display: inline-block;
    width: 30px;
    height: 30px;
    border: 1px solid #e2e2e2;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size: 1rem; 
  }
  ul.pagination li:first-child{ border-radius: 5px 0 0 5px; }
  ul.pagination li:last-child{ border-radius: 0 5px 5px 0; }
  ul.pagination li a { text-decoration: none; color: #337ab7; font-size: 1rem; }
  ul.pagination li.active a { color: white; }
  ul.pagination li.active { background-color: #337ab7; }
  ul.pagination li a:hover,
  ul.pagination li a.active { color: blue; }
`

const TagContainer = styled.div`
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
    justify-content: center;
`;

const DetailTag = styled.span`
    display: inline-flex;
    align-items: center;
    background-color: #f8f9fa;
    border: 1px solid #dee2e6;
    border-radius: 4px;
    padding: 2px 8px;
    font-size: 0.85rem;
`;

const TagLabel = styled.span`
    font-weight: 700;
    color: #495057;
    margin-right: 6px;
    &::after {
        content: ":";
        margin-left: 2px;
    }
`;

const TagValue = styled.span`
    color: #212529;
`;

export default ActionLog;